import { render } from "./deactivate-employee-modal.vue?vue&type=template&id=9812ce60&scoped=true"
import script from "./deactivate-employee-modal.vue?vue&type=script&lang=js"
export * from "./deactivate-employee-modal.vue?vue&type=script&lang=js"

import "./deactivate-employee-modal.vue?vue&type=style&index=0&id=9812ce60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9812ce60"]])

export default __exports__